import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8 max-w-2xl mx-auto" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Departments", -1)
const _hoisted_4 = { class: "text-2xl font-extrabold text-[#1E2833]" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "bg-white rounded-2xl border border-gray-100 overflow-hidden" }
const _hoisted_8 = { class: "px-8 py-5 border-b border-gray-100 flex items-center gap-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-xl bg-[#6CC551]/10 flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5 text-[#6CC551]",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    })
  ])
], -1)
const _hoisted_10 = { class: "text-sm font-semibold text-[#1E2833]" }
const _hoisted_11 = { class: "text-xs text-gray-500" }
const _hoisted_12 = { class: "p-8 space-y-6" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1.5 text-xs font-semibold text-gray-600" }, [
  /*#__PURE__*/_createTextVNode("Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-400" }, "*")
], -1)
const _hoisted_15 = { class: "h-64" }
const _hoisted_16 = { class: "px-8 py-5 border-t border-gray-100 bg-gray-50/50" }

import { initTooltips } from "flowbite";
import { onMounted } from "vue";
import { QuillEditor } from '@vueup/vue-quill';
import { reactive, ref, computed } from 'vue';
import axios from 'axios';
import { useRoute, useRouter } from "vue-router";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Button from "@/components/Inputs/Button.vue";
import InputField from "@/components/Inputs/InputField.vue";
import SelectField from "@/components/Inputs/SelectField.vue";
import { url } from '@/functions/endpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDepartments',
  setup(__props) {

const uploading = ref(false);
let successMessage = ref<string>('');
let showSuccessMessage = ref<boolean>(false);
let errorAlert = ref<boolean>(false);
let errorMessage = ref<string>('');
let isUnit = ref<boolean>(false)
const isEditing = ref<boolean>(false);
const route = useRoute();
const postId = computed(() => route.params.id);
const editType = computed(() => route.name);
console.log(editType, 'edit');

const router = useRouter();
const data = reactive({
  title: '',
  description: '',
  department: ''
})

onMounted(() => {
  initTooltips();
  getDepartmentDetails();
});

const handleChecked = () => {
  isUnit.value = !isUnit.value;
}

const departmentInfo = ref([]);
const getDepartmentDetails = async () => {
  if (postId.value !== undefined) {
    isEditing.value = true;
    if (isEditing.value) {
      try {
        const response = await axios.get( editType.value === "EditDepartment" ? `${url}/departments/${postId.value}` : `${url}/unit/${postId.value}`);
        const documentData = response.data;
        departmentInfo.value = documentData
        data.title = editType.value === "EditDepartment" ? documentData.name : documentData.title;
        data.description = documentData.about;
        data.department = documentData?.department?.id;
      } catch (error: any) {
        errorAlert.value = true;
        errorMessage.value = error.message
      }
    } else {
      console.log('creating');
    }
  }
}

const handleAddUnit = async () => {
  try {
    if (!isEditing.value) {
      await axios.post(`${url}/unit`, { title: data.title, about: data.description, departmentId: parseInt(data.department) })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    } else {
      await axios.patch(`${url}/unit/update/${postId.value}`, { title: data.title, about: data.description, departmentId: parseInt(data.department) })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    }

    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-departments');
      } else {
        window.location.href = "/admin/add-department"
      }
    }, 1000);
  }
  catch (error: any) {
    errorAlert.value = true;
    errorMessage.value = error.message;
    setTimeout(() => {
      errorAlert.value = false;
    }, 5000)
  }
};

const handleAddDepartment = async () => {
  try {
    if (!isEditing.value) {
      await axios.post(`${url}/departments/create/department`, { name: data.title, about: data.description, })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    } else {
      await axios.patch(`${url}/departments/update/${postId.value}`, { name: data.title, about: data.description, })
        .then((response) => {
          showSuccessMessage.value = true
          successMessage.value = response.data.message;
        })
    }
    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-departments');
      } else {
        window.location.href = "/admin/add-department"
      }
    }, 1000);
  }
  catch (error: any) {
    errorAlert.value = true;
    errorMessage.value = error.message;
    setTimeout(() => {
      errorAlert.value = false;
    }, 5000)
  }
};

const allDepartments: any = ref([]);
axios.get(`${url}/departments`)
  .then((response: any) => {
    allDepartments.value = response.data;
    console.error(allDepartments.value);
  })
  .catch((error: string) => {
    console.error(error);
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h1", _hoisted_4, [
          (_unref(isUnit) || _unref(editType) === 'EditUnit')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(isEditing.value ? "Edit Unit" : "Add Unit"), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(isEditing.value ? "Edit Department" : "Add Department"), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(isUnit) || _unref(editType) === 'EditUnit' ? 'Unit Details' : 'Department Details'), 1),
            _createElementVNode("p", _hoisted_11, " Fill in the information below to " + _toDisplayString(isEditing.value ? 'update the' : 'create a new') + " " + _toDisplayString(_unref(isUnit) || _unref(editType) === 'EditUnit' ? 'unit' : 'department'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (!isEditing.value)
            ? (_openBlock(), _createBlock(InputField, {
                key: 0,
                label: "Is this a unit? Check to create a unit, uncheck to create a department",
                id: "isUnitCheckbox",
                value: _unref(isUnit),
                type: "checkbox",
                placeholder: "Unit",
                isRequired: false,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isUnit) //@ts-ignore
 ? isUnit.value = $event.target.checked : isUnit = $event.target.checked))
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _createVNode(InputField, {
            label: "Title",
            id: "title",
            type: "text",
            placeholder: _unref(isUnit) ? 'Enter unit title' : 'Enter department title',
            isRequired: true,
            modelValue: data.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.title) = $event))
          }, null, 8, ["placeholder", "modelValue"]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(QuillEditor), {
                contentType: "html",
                theme: "snow",
                content: data.description,
                "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((data.description) = $event))
              }, null, 8, ["content"])
            ])
          ]),
          (_unref(isUnit) || _unref(editType) === 'EditUnit')
            ? (_openBlock(), _createBlock(SelectField, {
                key: 1,
                class: "mt-20",
                label: "Select department",
                id: "departments",
                placeholder: "Select department",
                modelValue: data.department,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.department) = $event)),
                options: allDepartments.value,
                param: 'name'
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_unref(isUnit) || _unref(editType) === 'EditUnit')
            ? (_openBlock(), _createBlock(Button, {
                key: 0,
                buttonText: isEditing.value ? 'Update Unit' : 'Add Unit',
                isDisabled: data.title === '' || data.description === '' || !data.department || uploading.value,
                uploading: uploading.value,
                handleClick: handleAddUnit
              }, null, 8, ["buttonText", "isDisabled", "uploading"]))
            : (_openBlock(), _createBlock(Button, {
                key: 1,
                buttonText: isEditing.value ? 'Update Department' : 'Add Department',
                isDisabled: data.title === '' || data.description === '' || uploading.value,
                uploading: uploading.value,
                handleClick: handleAddDepartment
              }, null, 8, ["buttonText", "isDisabled", "uploading"]))
        ])
      ])
    ]),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})